/**
 * @module FE-CU18_ALSOKへのお問い合わせ画面
 */
import Header from '../../../components/header/Header.vue';
import BreadCrumbList from '@/components/breadCrumb/List.vue';
import PcPageTitle from '@/components/pcPageTitle/PcPageTitle.vue';
import Contact from '../../../components/contact/Contact.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import ListPanel from '../../../components/listPanel/ListPanel.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU18';

export default {
  name: 'AboutContractAndItem',
  components: {
    Header,
    BreadCrumbList,
    PcPageTitle,
    Contact,
    MobileFooter,
    ListPanel,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU18ALSOKへのお問い合わせ画面.ALSOKへのお問い合わせ'), //"ALSOKへのお問い合わせ",
      isDisabledPhoneNumber: false,
      contentsInfo: {
        displayDistrictInfo: {
          displayDistrictFacilityName: '',
          usagePlanId: 0,
          customerNumber: '',
          displyaDistrictNickname: '',
          districtSplitNumber: '',
        },
        cameraInfo: {
          displayDistrictFacilityName: '',
          usagePlanId: 0,
          customerNumber: '',
          displyaDistrictNickname: '',
          cameraNickName: '',
          districtSplitNumber: '',
        },
        contactUsInfo: {
          orderOfficeName: '',
          orderOfficePhoneNumber: '',
        },
      },
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU18ALSOKへのお問い合わせ画面.C0001'),
      //"ALSOKへのお問い合わせの電話番号となります。\n\r画面に表示されている注意事項をご確認の上お電話ください。",
      clientNumber: '',
      displayAreaTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      displayAreaList: [],
      cameraTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      cameraList: [],
      notificationImage: require('../../../assets/images/icon/notification.png'),
      orderOfficeName: '',
      orderOfficePhoneNumber: '',
      orderGcName: '',
      orderGcPhoneNumber: '',
      displayType: 0,
      CONSTANTS: CONSTANTS,
      usagePlan: 0,
      originalPlan: -1, // #27540
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU18ALSOKへのお問い合わせ画面.ALSOKへのお問い合わせ'), //"ALSOKへのお問い合わせ",
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU18ALSOKへのお問い合わせ画面.C0001'
        ), //"ALSOKへのお問い合わせの電話番号となります。\n画面に表示されている注意事項をご確認の上お電話ください。"
        displayAreaList: [
          {
            id: 1,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.利用プラン'
            ), //"利用プラン",
            text: 'オンライン監視プラン',
          },
          {
            id: 2,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.お客様番号'
            ), //"お客様番号",
            text: '51-1234567',
          },
          {
            id: 3,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.警備先名'
            ), // "警備先名",
            text: '警備先1',
          },
          {
            id: 4,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.地区番号'
            ), //"地区番号",
            text: '0001',
          },
        ],
        cameraList: [
          {
            id: 1,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.利用プラン'
            ), //"利用プラン",
            text: 'カメラ(かけつけ依頼)',
          },
          {
            id: 2,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.お客様番号'
            ), //"お客様番号",
            text: '51-1234567',
          },
          {
            id: 3,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.警備先名'
            ), // "警備先名",,
            text: '警備先1',
          },
          {
            id: 4,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.地区番号'
            ), //"地区番号",
            text: '0001',
          },
          {
            id: 5,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.地区番号'
            ), //"地区番号",
            text: '地区名1',
          },
        ],
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 契約・商品に関するお問い合わせデータ取得(表示地区)API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns apiData レスポンス
     */
    async APP_CU1801(param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ(対象地区)
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       displayDistrictFacilityName: "自宅",
            //       usagePlan: 0,
            //       customerNumber: "51-12345678",
            //       securityDestinationName: "警備先名1",
            //       districtSplitName: "地区名1",
            //       districtSplitNumber: "0001",
            //     },
            //     contactUsInfo: {
            //       orderOfficeName: "受注事業所名称1",
            //       orderOfficePhoneNumber: "00-0000-0001",
            //       orderGcName: "ガードセンター名",
            //       orderGcPhoneNumber: "00-0000-0002",
            //     },
            //   },
            // };

            // 取得したデータを画面に出力する。
            // 動的対応で追記
            const targetItem = apiData.contentsInfo.displayDistrictInfo;

            const labels = {
              usagePlan:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.利用プラン',
              customerNumber:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.警備先名',
              districtSplitNumber:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.地区番号',
              districtSplitName:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.地区名',
            };

            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitName',
              'districtSplitNumber',
            ];

            const planTitles = {
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
            };

            Object.keys(targetItem).map((key) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                  this.usagePlan = targetItem[key];
                  switch (this.usagePlan) {
                    case 0:
                      // 事業所
                      this.orderOfficeName = apiData.contentsInfo.contactUsInfo.orderOfficeName;
                      this.orderOfficePhoneNumber =
                        apiData.contentsInfo.contactUsInfo.orderOfficePhoneNumber;
                      // GC
                      this.orderGcName = apiData.contentsInfo.contactUsInfo.orderGcName;
                      this.orderGcPhoneNumber =
                        apiData.contentsInfo.contactUsInfo.orderGcPhoneNumber;
                      break;
                    case 1:
                    case 2:
                      // 事業所
                      this.orderOfficeName = apiData.contentsInfo.contactUsInfo.orderOfficeName;
                      this.orderOfficePhoneNumber =
                        apiData.contentsInfo.contactUsInfo.orderOfficePhoneNumber;
                      this.orderGcName = apiData.contentsInfo.contactUsInfo.orderGcName;
                      this.orderGcPhoneNumber =
                        apiData.contentsInfo.contactUsInfo.orderGcPhoneNumber;
                      break;
                    case 3:
                    case 4:
                      // 事業所
                      this.orderOfficeName = apiData.contentsInfo.contactUsInfo.orderOfficeName;
                      this.orderOfficePhoneNumber =
                        apiData.contentsInfo.contactUsInfo.orderOfficePhoneNumber;
                      // フリーダイヤル
                      this.orderGcPhoneNumber = this.$vuetify.lang.t(
                        '$vuetify.FECU18ALSOKへのお問い合わせ画面.フリーダイヤル.電話番号'
                      );
                      break;
                  }
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '') {
                    return;
                  }
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU18ALSOKへのお問い合わせ画面.メイン地区';
                  }
                }
                this.displayAreaList = [
                  ...this.displayAreaList,
                  { title: labels[key], text: text },
                ];
              }
            });
            this.displayAreaTitle = {
              place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname} `,
              type: '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.対象地区',
              typeIsBefore: true,
            };
            this.clientNumber = apiData.contentsInfo.displayDistrictInfo.customerNumber;
          },
          (error /* eslint-disable-line */) => {
            // レスポンスステータス403の場合、トップページへリダイレクト
            if (error.message.includes('403')) {
              this.$router.replace({
                path: '/top',
              });
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 契約・商品に関するお問い合わせデータ取得(カメラ)API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @return {*} apiData レスポンス
     */
    async APP_CU1802(param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ(対象地区)
            // apiData = {
            //   contentsInfo: {
            //     cameraInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-12345678",
            //       securityDestinationName: "警備先名1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区番号1",
            //       displayDistrictNickname: "ニックネーム(対象地区)",
            //       cameraNickName: "リビングカメラ",
            //     },
            //     contactUsInfo: {
            //       orderOfficeName: "受注事業所名称1",
            //       orderOfficePhoneNumber: "00-0000-0001",
            //       orderGcName: "ガードセンター名",
            //       orderGcPhoneNumber: "00-0000-0002",
            //     },
            //   },
            // };

            // 取得したデータを画面に出力する。
            // 動的対応で追記
            const targetItem = apiData.contentsInfo.cameraInfo;
            this.originalPlan = apiData.contentsInfo.cameraInfo.originalPlan; // #27540 no... good....
            const labels = {
              usagePlan:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.利用プラン',
              customerNumber:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.警備先名',
              districtSplitNumber:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.地区番号',
              districtSplitName:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.地区名',
              displayDistrictNickname:
                '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.ニックネーム',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
            ];
            const planTitles = {
              [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
            };
            Object.keys(targetItem).map((key) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                  this.usagePlan = targetItem[key];

                  switch (this.usagePlan) {
                    case 0:
                      // 事業所
                      this.orderOfficeName = apiData.contentsInfo.contactUsInfo.orderOfficeName;
                      this.orderOfficePhoneNumber =
                        apiData.contentsInfo.contactUsInfo.orderOfficePhoneNumber;
                      // GC
                      this.orderGcName = apiData.contentsInfo.contactUsInfo.orderGcName;
                      this.orderGcPhoneNumber =
                        apiData.contentsInfo.contactUsInfo.orderGcPhoneNumber;
                      break;
                    case 101:
                      // 事業所
                      this.orderOfficeName = apiData.contentsInfo.contactUsInfo.orderOfficeName;
                      this.orderOfficePhoneNumber =
                        apiData.contentsInfo.contactUsInfo.orderOfficePhoneNumber;
                      this.orderGcName = apiData.contentsInfo.contactUsInfo.orderGcName;
                      this.orderGcPhoneNumber =
                        apiData.contentsInfo.contactUsInfo.orderGcPhoneNumber;
                      break;
                    case 102:
                      // 事業所
                      // フリーダイヤル
                      this.orderGcPhoneNumber = this.$vuetify.lang.t(
                        '$vuetify.FECU18ALSOKへのお問い合わせ画面.フリーダイヤル.電話番号'
                      );
                      break;
                  }
                  // #27540 no good....
                  // 監視プランで電話番号を上書き
                  if (this.originalPlan === 0) {
                    this.orderOfficeName = apiData.contentsInfo.contactUsInfo.orderOfficeName;
                    this.orderOfficePhoneNumber =
                      apiData.contentsInfo.contactUsInfo.orderOfficePhoneNumber;
                    // GC
                    this.orderGcName = apiData.contentsInfo.contactUsInfo.orderGcName;
                    this.orderGcPhoneNumber = apiData.contentsInfo.contactUsInfo.orderGcPhoneNumber;
                  }
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '') {
                    return;
                  }
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU18ALSOKへのお問い合わせ画面.メイン地区';
                  }
                }
                this.cameraList = [...this.cameraList, { title: labels[key], text: text }];
              }
            });
            this.clientNumber = apiData.contentsInfo.cameraInfo.customerNumber;
            this.cameraTitle = {
              place: `- ${apiData.contentsInfo.cameraInfo.cameraNickName} `,
              type: '$vuetify.FECU18ALSOKへのお問い合わせ画面.対象地区詳細カメラ詳細表示領域.カメラ',
              typeIsBefore: true,
            };
          },
          (error) => {
            // レスポンスステータス403の場合、トップページへリダイレクト
            if (error.message.includes('403')) {
              this.$router.replace({
                path: '/top',
              });
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 遷移元判定処理
     * @returns ページ遷移元コード
     */
    judgeAncestor() {
      switch (this.displayType) {
        case 1:
          return this.CONSTANTS.PAGE_ANCESTOR_CODE.HOME_SECURITY;
        case 2:
          return this.CONSTANTS.PAGE_ANCESTOR_CODE.CAMERA;
        default:
          return null;
      }
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.displayType = this.$store.state.currentDisplayType;

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //何故か、以下通信でローディングマークを出してるので、ここで画面表示
    this.isShowPage = true;

    let param =
      this.displayType === 1
        ? '/api/contact/contactDataDisplayDistrict'
        : '/api/contact/contactDataCamera';
    // let param = "post"; // カメラの場合はcontactDataCamera

    if (this.displayType === 1) {
      // 対象地区の場合
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
      };
      let method = 'post';

      await this.APP_CU1801(param, queries, method);
    } else {
      // カメラの場合
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
      };

      let method = 'post';
      await this.APP_CU1802(param, queries, method);
    }
  },
};
